module.exports = __webpack_public_path__ + "img/icon-128x128.61dbd703.png";